<template>
    <div class="information">
        <div class="list">
            <div class="text">信息科技，提升效率</div>
            <div class="logo">
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.information {

    // width: 1920px;
    .list {
        width: 100%;
        position: relative;
        height: 185px;
        background-color: #112489;

        .text {
            position: absolute;
            left: calc(50% - 108px);
            margin: 80px auto 0;
            // width: 216px;
            height: 30px;
            font-size: 30px;
            font-family: Source Code Pro-Bold, Source Code Pro;
            font-weight: bold;
            color: #FFFFFF;
            line-height: 28px;
        }
        .logo {
            width: 100%;
            // width: 1920px;
            height: 221px;
            position: absolute;
            bottom: 0;
            border-radius: 0px 0px 0px 0px;
            opacity: 1;
            background-image: url(../assets/guiwei-logo/大厦背景.png);
            background-repeat: no-repeat;
            background-position: 100% 100%;
            background-size: 100%;
        }
    }
}
</style>